import { HttpErrorResponse } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import { Screen } from '@core/interfaces';

import {
  UserCreateResponseBody,
  UserDetailResponseBody,
  UserLookupResponseBody,
  UserUpdateRequest,
  UserUpdateResponseBody,
} from '#types/admin';
import { ErrorResponse } from '#types/core';
import { Filters, Sorts } from '#types/grid';
import { ImageDeleteResponseBody, ImageUploadResponseBody } from '#types/image';

//
// admin / upload image
//

export const UploadImageInitialize = createAction('[Admin.Image-Upload] - Initialize', props<{ screen: Screen }>());

export const UploadImageRequest = createAction('[Admin] - Upload Image Request', props<{ formData: FormData }>());
export const UploadImageRequestSuccess = createAction('[Admin] - Upload Image Request Success', props<{ data: ImageUploadResponseBody }>());
export const UploadImageRequestFailure = createAction('[Admin] - Upload Image Request Failure', props<{ error: ErrorResponse }>());

//
// admin / delete image
//

export const DeleteImageRequest = createAction('[Admin] - Delete Image Request', props<{ imageType: string }>());
export const DeleteImageRequestSuccess = createAction('[Admin] - Delete Image Request Success', props<{ data: ImageDeleteResponseBody }>());
export const DeleteImageRequestFailure = createAction('[Admin] - Delete Image Request Failure', props<{ error: ErrorResponse }>());

//
// admin / user lookup
//

export const LookupInitialize = createAction('[Admin.User-Lookup] - Initialize', props<{ screen: Screen }>());

export const LookupRequestData = createAction('[Admin.User-Lookup] - Grid Request Data', props<{ id: string }>());

export const LookupRequestDataSuccess = createAction(
  '[Admin.User-Lookup] - Grid Request Data Success',
  props<{ id: string; data: UserLookupResponseBody }>()
);
export const LookupRequestDataFailure = createAction('[Admin.User-Lookup]  - Grid Request Data Failure', props<{ id: string }>());

export const LookupRequestDataWithParameters = createAction(
  '[Admin.User-Lookup] - Grid Request Data With Parameters',
  props<{ id: string; filters: Filters; page: number; first: number; rows: number; sorts: Sorts }>()
);

export const LookupRequestDataWithFilters = createAction(
  '[Admin.User-Lookup] - Grid Request Data With Filters',
  props<{ id: string; filters: Filters }>()
);

export const LookupRequestDataForExport = createAction(
  '[Admin.User-Lookup] - Request Data For Export',
  props<{ id: string; format: string; rows: number }>()
);

//
// admin / user detail
//

export const DetailInitialize = createAction('[Admin.User-Detail] - Initialize', props<{ screen: Screen }>());

export const DetailRequestData = createAction('[Admin.User-Detail] - Request Data', props<{ nameid: string }>());

export const DetailRequestDataSuccess = createAction(
  '[Admin.User-Detail] - Request Data Success',
  props<{ nameid: string; data: UserDetailResponseBody }>()
);

export const DetailRequestDataFailure = createAction('[Admin.User-Detail] - Request Data Failure');

export const DetailClearData = createAction('[Admin.User-Detail] - Clear Data');

//
// admin / user create
//

export const CreateUserInitialize = createAction('[Admin.Create-User] - Initialize', props<{ screen: Screen }>());

export const CreateUserRequest = createAction('[Admin.Create-User] - Create User Request', props<{ username: string; password: string }>());

export const CreateUserRequestSuccess = createAction(
  '[Admin.Create-User] - Create User Request Success',
  props<{ username: string; password: string; data: UserCreateResponseBody }>()
);

export const CreateUserRequestFailure = createAction(
  '[Admin.Create-User] - Create User Request Failure',
  props<{ error: HttpErrorResponse }>()
);

//
// admin / user update
//

export const UpdateUserRequest = createAction('[Admin.Update-User] - Update Detail Data Request', props<{ data: UserUpdateRequest }>());

export const UpdateUserRequestSuccess = createAction(
  '[Admin.Update-User] - Update Detail Request Data  Success',
  props<{ data: UserUpdateResponseBody }>()
);

export const UpdateUserRequestFailure = createAction(
  '[Admin.Update-User] - Update Detail Request Data Failure',
  props<{ error: HttpErrorResponse }>()
);

export const UpdateUserDetailRequest = createAction(
  '[Admin.Update-User-Detail] - Update User Detail Data Request',
  props<{ data: UserUpdateRequest }>()
);
